import ApiModel from '../ApiModel'
import { createSelector } from 'reselect'
import Action from '../Action'
import { registerModelReducer } from '../reducers'
import { ApiSuccessAction } from '../types'
import { Connection } from './types'

const MODEL = new ApiModel('MARKETING_USER_INTERACTION', 'api/v1/marketing_user_interactions')

type ModelState = {
  hasUpdated: boolean
  status: number | null
}

const { modelStateSelector } = registerModelReducer<ModelState>(
  'marketingUserInteraction',
  (state = { hasUpdated: false, status: null }, action,
  ) => {
    const { type, response } = action as ApiSuccessAction

    if (type === Action.UPDATE_MODIFY.successType(MODEL)) {
      return { ...state, hasUpdated: true, status: response?.status }
    } else if (type === Action.UPDATE_MODIFY.failureType(MODEL)) {
      return { ...state, hasUpdated: false, status: response?.status }
    }
    return state
  })

const optOutUpdate = async (uuid: string, optOutKey: string) =>
  await MODEL.updateModify({}, { id: uuid, query: { opt_out_key: optOutKey } })

const hasUpdated = modelStateSelector(state => state.hasUpdated)
const status = modelStateSelector(state => state.status)

const selectAvailableConnection = createSelector(
  [hasUpdated, status],
  (hasUpdated, status) => ({
    hasUpdated,
    status,
    optOutUpdate,
  }),
)

export const MarketingUserInteraction: {
  connection: Connection<ModelState & {
    optOutUpdate: (uuid: string, optOutKey: string) => void
  }>
} = {
  connection: {
    selector: selectAvailableConnection,
  },
}
